import { useTranslation } from 'react-i18next';
import * as Styled from './FrequencyDropdown.styled';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FrequencyDropdown = ({
  frequencySelectValue,
  handleSelectChange,
  recurringFrequencyOptions
}) => {
  const {
    t
  } = useTranslation(['blocks.donation', 'blocks.common']);
  return /*#__PURE__*/_jsxs(Styled.FrequencyDropdownContainer, {
    children: [/*#__PURE__*/_jsx("span", {
      children: t('FrequencyDropdown.donationFrequency.label', 'Donation Frequency')
    }), /*#__PURE__*/_jsx(Styled.DonationFrequencySelect, {
      "data-id": "cp-donation-form-frequency",
      name: "donation-frequency",
      value: frequencySelectValue,
      onChange: e => {
        e.preventDefault();
        handleSelectChange(e.target.value);
      },
      children: recurringFrequencyOptions.map(frequencyOption => /*#__PURE__*/_jsx("option", {
        value: frequencyOption,
        children: t(`blocks.common:Frequency.${frequencyOption}`)
      }, frequencyOption))
    })]
  });
};